import Registration from "../pages/student/auth/Registration";
import StudentDashboard from "../layout/student/StudentDashboard";
import Profile from "../pages/student/Profile";
import LoginPage from "../pages/student/auth/Login";
import Attendance from "../pages/student/Attendance";
import Reports from "../pages/student/Reports";
import StudentAuthWrapper from "../AuthWrapper/StudentAuthWrapper";
import DailyReport from "../pages/student/DailyReport";
import HomePage from "../pages/student/HomePage"; // <-- Import HomePage
import ProfilePage from "../pages/student/Profile";
import ForgotPassword from "../components/auth/ForgotPassword";
import ResetPassword from "../components/auth/ResetPassword";

const studentRoutes = [
    {
        path: '/',
        element: (
        <StudentAuthWrapper>
            <StudentDashboard />
        </StudentAuthWrapper>
        ),
        children: [
            {
                index: true,
                element: <HomePage />  // <-- Show HomePage first
            },
            {
                path: 'daily-report',   // <-- Give DailyReport a proper path
                element: <Reports />
            },
            {
                path: 'profile',
                element: <ProfilePage />
            },
            {
                path: 'attendance',
                element: <Attendance />
            }
         
        ]
    },
    {
        path: 'registration',
        element: <Registration />
    },
    {
        path: 'login',
        element: <LoginPage />
    },
    {
        path: 'forgot-password',
        element: <ForgotPassword />
    },
    {
        path: 'reset-password/:token',
        element: <ResetPassword />
    }
]

export default studentRoutes;
